// src/pages/Home/Components/NewProduct.jsx
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ProductCard from '../../../components/ui/ProductCard';
import ErrorBoundary from '../../../components/ErrorBoundary';

const NewProduct = () => {
  const { products = [], loading = false } = useSelector((state) => state.listProduct) || {};

  const newProducts = useMemo(() => {
    return [...products]
      .filter((product) => Number(product.countInStock) > 0)
      .sort(
        (firstProduct, secondProduct) =>
          new Date(secondProduct.createdAt) - new Date(firstProduct.createdAt)
      )
      .slice(0, 10);
  }, [products]);

  if (loading) {
    return (
      <section dir="rtl" className="mx-auto mt-8 w-[95%] max-w-[1280px]">
        <div className="relative h-[190px] overflow-hidden rounded-t-[24px] bg-[#A5B394]">
          <div className="mx-auto mt-6 h-[88px] w-[80%] max-w-[510px] animate-pulse rounded-lg bg-white/80" />
          <div className="absolute -bottom-10 left-0 right-0 flex gap-3 px-3">
            {Array.from({ length: 5 }).map((_, index) => (
              <div
                key={index}
                className="h-[210px] min-w-[170px] flex-1 animate-pulse rounded-lg bg-white/80"
              />
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section dir="rtl" className="mx-auto mt-8 w-[95%] max-w-[1280px]">
      <header className="relative h-[180px] overflow-visible rounded-t-[24px] bg-[#A5B394] sm:h-[195px]">
        <div className="flex justify-center pt-6 sm:pt-7">
          <div className="flex min-h-[90px] w-[82%] max-w-[510px] flex-col items-center justify-center gap-3 rounded-lg bg-white px-4 py-1 text-center shadow-sm sm:rounded-xl">
            <h2 className="text-sm font-extrabold text-[#252525] sm:text-base md:text-lg">
              جدیدترین محصولات اریس گالری
            </h2>

            <button
              type="button"
              onClick={() => { window.location.href = '/products'; }}
              className="rounded-md bg-[#8A9A7B] px-6 py-2 text-xs font-bold text-white transition-colors hover:bg-[#788868] sm:text-sm"
            >
              هر روز سر بزن
            </button>
          </div>
        </div>
      </header>

      <div className="relative z-10 -mt-12 px-1 sm:-mt-14 sm:px-2">
        <ErrorBoundary fallbackMessage="مشکلی در نمایش جدیدترین محصولات پیش آمد.">
          {newProducts.length > 0 ? (
            <Swiper
              dir="rtl"
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true, dynamicBullets: true }}
              className="!w-full !pb-12"
              spaceBetween={12}
              slidesPerView={1.25}
              breakpoints={{
                0: { slidesPerView: 1.2, spaceBetween: 10 },
                320: { slidesPerView: 1.5, spaceBetween: 10 },
                420: { slidesPerView: 2, spaceBetween: 12 },
                560: { slidesPerView: 2.7, spaceBetween: 14 },
                640: { slidesPerView: 3, spaceBetween: 14 },
                768: { slidesPerView: 3.5, spaceBetween: 16 },
                950: { slidesPerView: 4, spaceBetween: 16 },
                1100: { slidesPerView: 4.5, spaceBetween: 18 },
                1280: { slidesPerView: 5, spaceBetween: 18 },
              }}
            >
              {newProducts.map((product) => (
                <SwiperSlide key={product._id || product.id} className="!h-auto">
                  <div className="px-1 py-2">
                    <ProductCard {...product} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="flex min-h-[150px] items-center justify-center rounded-xl bg-white text-sm text-gray-500 shadow-sm">
              محصول جدیدی موجود نیست.
            </div>
          )}
        </ErrorBoundary>
      </div>
    </section>
  );
};

export default NewProduct;